export enum CONTENT_TYPE_ENUM {
  THREE_HUNDRED_SIXTY_PHOTO = "360 Photo",
  THREE_DIMENSIONAL_MODEL = "3D Model",
  VIRTUAL_TOUR = "Virtual Tour",
  VIDEO = "Video",
  PHOTO = "Photo",
  PDF = "PDF",
  LINK = "Link",
  AUDIO = "Audio",
}

export const CONTENT_TYPE = {
  THREE_HUNDRED_SIXTY_PHOTO: "360 Photo",
  THREE_DIMENSIONAL_MODEL: "3D Model",
  VIRTUAL_TOUR: "Virtual Tour",
  VIDEO: "Video",
  PHOTO: "Photo",
  PDF: "PDF",
  LINK: "Link",
  AUDIO: "Audio",
} as const;

export type CONTENT_TYPE = (typeof CONTENT_TYPE)[keyof typeof CONTENT_TYPE];

const SUPPORTED_FILE_TYPES = {
  IMAGE: ["bmp", "gif", "ico", "jpg", "jpeg", "png", "webp"],
  AUDIO: ["aac", "flac", "mp3", "m4a", "ogg", "wav"],
  DOCUMENT: ["pdf"],
};

export const ALL_SUPPORTED_FILE_TYPES = [
  ...SUPPORTED_FILE_TYPES.IMAGE,
  ...SUPPORTED_FILE_TYPES.AUDIO,
  ...SUPPORTED_FILE_TYPES.DOCUMENT,
];
